export enum AgentType {
  CODING = 'CODING',
  DEBUGGING = 'DEBUGGING',
}
